import { rem } from 'polished'
import styled from 'styled-components'
import JustAddedLabel from 'tripPlanner/components/JustAddedLabel'

/** Displays when the card's content area is at least 580px wide */
export const WideCardOnlyJustAddedLabel = styled(JustAddedLabel)`
  display: none;

  @container (min-width: 580px) {
    display: inline-flex;
  }
`

/** Displays when the card's content area is less than 580px wide */
export const NarrowCardOnlyJustAddedLabel = styled(JustAddedLabel)`
  @container (min-width: 580px) {
    display: none;
  }

  &.bottom-margin {
    margin-bottom: ${rem(8)};
  }
`
